module.exports = __webpack_public_path__ + "static/media/luis-contreras.0a6a5d24.jpg";